import { GeneralQuizVerificationFn } from './types';

export const useNoVerification: GeneralQuizVerificationFn = () => ({
  verificationPassed: true,
  verificationLoading: false,
});
